export const HEADERSTATUS = {
  TERMINATED: "terminated",
  SCHEDULED: "scheduled",
  PENDING: "pending",
  COMPLETED: "completed",
};

export const MEMBER_EVENTS = {
  NEW_HIRE_REQUESTED: "new_hire_requested",
  EE_INFO_SUBMITTED: "ee_info_submitted",
  EA_GENERATED: "ea_generated",
  EE_CONTACTED: "ee_contacted",
  EA_SENT_FOR_SIGNATURE: "ea_sent_for_signature",
  EA_SIGNED_BY_EE: "ea_signed_by_ee",
};
